import React, { useState, useRef } from "react";
import classNames from "classnames";
import { ClipboardListIcon, DownloadIcon } from "@heroicons/react/solid";
import { getDetailSegment } from "../../../utils/buro";
import { ModalDialog } from "components/LoanSandbox/LoanSandboxId";
import _ from "lodash";
import { format } from "date-fns";
import { API, Auth } from "aws-amplify";
import { useSelector } from "react-redux";

export const Wrapper = ({ children, ...props }) => {
  return (
    <div className="flex justify-center items-center h-screen w-full">
      {children}
    </div>
  );
};

export const WrapperCard = ({ children, ...props }) => {
  return (
    <div className="flex justify-center items-center space-x-2 w-1/2">
      {children}
    </div>
  );
};

export const Card = ({ loan, buroDate, setLoan, setOriLoan, ...props }) => {
  const [openModal, setOpenModal] = useState(false);
  const [dataJson, setDataJson] = useState();
  const [oriDataJson, setOriDataJson] = useState();
  const [search, setSearch] = useState("");
  const ref = useRef(null);

  const onClickView = () => {
    const dataBuro = getDetailSegment({
      currentDate: buroDate,
      dataExport: [loan],
      showLog: true,
    });
    setDataJson(_.cloneDeep(dataBuro));
    setOriDataJson(_.cloneDeep(dataBuro));
    setOpenModal(true);
  };

  const onChangeSearch = (e) => {
    const { value } = e.target;
    setDataJson((prev) => {
      return oriDataJson?.filter((row) => {
        return (
          row?.tag?.toLowerCase().includes(value.toLowerCase()) ||
          row?.key?.toLowerCase().includes(value.toLowerCase())
        );
      });
    });
    setSearch(value);
  };

  const onChangeCheckedLoan = (e) => {
    const checked = e.target.checked;
    setLoan((prev) => {
      const temp = [...prev];
      const findIndex = temp.findIndex((item) => item.loan_id === loan.loan_id);
      temp[findIndex].checked = checked;
      return temp;
    });
    setOriLoan((prev) => {
      const temp = [...prev];
      const findIndex = temp.findIndex((item) => item.loan_id === loan.loan_id);
      temp[findIndex].checked = checked;
      return temp;
    });
  };

  const getBorderStyleWidthStatus = (loan_status) => {
    if (loan_status === "ACTIVE") {
      return "text-green-500";
    } else if (loan_status === "LATE") {
      return "text-red-500";
    } else if (loan_status === "PENDING") {
      return "text-yellow-500";
    } else if (loan_status === "DONE") {
      return "text-green-600";
    }
    return "";
  };

  return (
    <div>
      <ModalDialog
        isSearch={true}
        search={search}
        onChangeSearch={onChangeSearch}
        title={`${loan.loan_kbank_id}`}
        setModal={setOpenModal}
        modal={openModal}
        ref={ref}
        dataJson={dataJson && dataJson}
      />
      <div className="border shadow-sm rounded px-5 py-3 w-full flex flex-col space-x-2 hover:bg-gray-200 duration-300 transition-all">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <div className="form-check">
              <input
                checked={loan.checked}
                onChange={onChangeCheckedLoan}
                type="checkbox"
                className="cursor-pointer"
                style={{ width: "20px", height: "20px" }}
              />
            </div>
            <div className="flex flex-col items-start ml-3 text-sm">
              <div>{loan.loan_kbank_id}</div>
              <div>{loan.fullname}</div>
            </div>
          </div>
          <div className="flex space-x-2 items-center ">
            <div
              className={classNames(
                "px-2 py-1 text-sm",
                getBorderStyleWidthStatus(loan.loan_status)
              )}
            >
              {loan?.loan_status}
            </div>
            <Button onClick={onClickView} color="green">
              View
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export const CardBuroBan = ({ loan, fetchBuroBan, ...props }) => {
  const { user } = useSelector((state) => state.initializeApp);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const ref = useRef(null);

  const getBorderStyleWidthStatus = (loan_status) => {
    if (loan_status === "BAN") {
      return "text-red-500";
    } else if (loan_status === "LATE") {
      return "text-red-500";
    } else if (loan_status === "PENDING") {
      return "text-yellow-500";
    } else if (loan_status === "DONE") {
      return "text-green-600";
    }
    return "";
  };

  const onClickDeleteBuro = async () => {
    try {
      setLoading(true);
      await API.del("MoneyHubAdmin", "/buro/deleteBuroBan", {
        body: {
          loan_kbank_id: loan.loan_kbank_id,
          username: user.username,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      await fetchBuroBan();
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="border shadow-sm rounded px-5 py-3 w-full flex flex-col space-x-2 hover:bg-gray-200 duration-300 transition-all relative">
        <div className="flex justify-between items-center">
          <div className="flex items-center flex-col">
            <div className="flex flex-row text-sm">
              <div className=" mr-4">{loan.loan_kbank_id}</div>
              <div>{loan.fullname}</div>
            </div>
            <div className="flex flex-row text-sm text-gray-400">
              <div className=" mr-4 -ml-5">
                {format(new Date(loan.createdAt), "dd-MM-yyyy")}
              </div>
              <div>{loan.addBy}</div>
            </div>
          </div>
          <div className="flex space-x-2 items-center ">
            <Button
              disabled={loan.action !== "EDIT"}
              color="red"
              onClick={onClickDeleteBuro}
            >
              DELETE
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export const CardDownload = ({ path, path_url, buroTime, count }) => {
  return (
    <div className="border shadow-sm rounded px-4 py-3 w-full flex flex-col space-x-2">
      <div className="flex items-center justify-between">
        <div className="flex flex-col items-start">
          <div>
            {path}&nbsp;&nbsp;&nbsp;{buroTime}&nbsp;({count})
          </div>
        </div>
        <a href={path_url}>
          <DownloadIcon className="h-6 w-6 text-blue-500 " />
        </a>
      </div>
    </div>
  );
};

export const Radio = ({ name, label, value, selectRadio, onChange }) => {
  return (
    <div class="flex items-center">
      <input
        onChange={onChange}
        id={`${name}-${value}`}
        type="radio"
        name={name}
        value={value}
        class="w-4 h-4 border-gray-300 focus:ring-2 focus:ring-blue-300 dark:focus:ring-blue-600 dark:focus:bg-blue-600 dark:bg-gray-700 dark:border-gray-600"
        aria-labelledby={name}
        aria-describedby={name}
        checked={selectRadio === value}
      />
      <label
        for={`${name}-${value}`}
        class="block ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
      >
        {label}
      </label>
    </div>
  );
};

export const Button = ({
  children,
  loading,
  onClick,
  disabled = false,
  color = "yellow",
  ...props
}) => {
  const colors = {
    yellow: "bg-yellow-500",
    red: "bg-red-500",
    orange: "bg-orange-500",
    green: "bg-green-500",
    blue: "bg-blue-500",
    emerald: "bg-emerald-500",
  };

  return (
    <button
      disabled={disabled || loading}
      className={classNames(
        "px-3 py-1 text-white flex flex-row rounded-lg items-center text-center ",
        {
          [colors[color]]: !loading,
          "bg-gray-400 cursor-not-allowed": loading || disabled,
        }
      )}
      onClick={onClick}
    >
      {loading && <Loading />}
      {children}
    </button>
  );
};

export const Tabs = ({ children, ...props }) => {
  return (
    <div className="border-b border-gray-200 dark:border-gray-700 ml-2">
      <ul className="flex flex-wrap -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400">
        {children}
      </ul>
    </div>
  );
};

export const WrapperIcon = ({ isActive, icon: Icon }) => {
  return (
    <Icon
      className={classNames("mr-2 w-5 h-5 dark:text-blue-500", {
        "text-blue-600 ": isActive,
      })}
    />
  );
};

export const IconDashboard = ({ className }) => {
  return (
    <svg
      className={className}
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"></path>
    </svg>
  );
};

export const IconList = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      stroke-width="2"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
      />
    </svg>
  );
};

export const Tab = ({ name, icon: Icon, setTab, tabValue = "", tab }) => {
  const onClickTab = () => {
    setTab(tabValue);
  };

  return (
    <li className="mr-2" onClick={onClickTab}>
      <div
        className={classNames(
          "inline-flex p-4 cursor-pointer rounded-t-lg  dark:text-blue-500 dark:border-blue-500 group",
          {
            "text-blue-600 border-b-2 border-blue-600": tab === tabValue,
          }
        )}
        aria-current="page"
      >
        <WrapperIcon isActive={tab === tabValue} icon={Icon} />
        {name}
      </div>
    </li>
  );
};

export const Input = ({ label, ...props }) => {
  return (
    <div className="flex flex-col items-start ">
      <label>{label}</label>
      <input
        {...props}
        className="py-2 px-4 border border-gray-200 rounded-lg"
      />
    </div>
  );
};

export const Loading = () => {
  return (
    <svg
      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx={12}
        cy={12}
        r={10}
        stroke="currentColor"
        strokeWidth={4}
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
};
